import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import { Swiper, SwiperSlide } from 'swiper/react';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { getReward } from '../../../utils/helpers';
import { nyTaskPrizeContent } from '../../../constants/copyright';
import { useTranslation } from '../../../translations';

const {
  navigation: { arrows, buttons },
} = nyTaskPrizeContent;

const NyTaskPrize = React.forwardRef(function NyTaskPrize({ prizes }, ref) {
  const { t } = useTranslation();
  return (
    <div className={`ny-task__prize`}>
      <Swiper watchOverflow={'auto'} slidesPerView={'auto'} loop={true} navigation={arrows}>
        {prizes?.map(({ prize, prize: { title, image }, count }, index) => {
          const { value } = getReward(prize, t) ?? {};
          return (
            <SwiperSlide key={'ny-task__prize-item-' + index} className={`ny-task__prize-slide`}>
              <div className={'ny-task__prize-item'}>
                <div className={'ny-task__prize-item-image'}>
                  <img src={image} className={'ny-task__prize-item-image-block'} alt={''} />
                  {typeof value === 'number' && <div className={'ny-task__prize-item-counter'}>+{value}</div>}
                </div>
                <h3 className={'ny-task__prize-item-title'}>{safeHTML(title)}</h3>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className={'ny-task__prize-nav'}>
        {buttons.map((item, index) => (
          <CustomButton key={index} {...item} />
        ))}
      </div>
    </div>
  );
});
export default NyTaskPrize;
NyTaskPrize.propTypes = {};
